/** 
 * Class to hold references to the different types of custom ArcGIS JS 
 * Widget Actions the app leverages.
 */
export class Actions {
  static GAUGE_DETAILS = 'gauge-details';
}